// EmptyState (HANDOFF §5.10, board system/empty--module): first use of a
// module = the mark at 30 % + one sentence + the decisive action (+ «استيراد
// من المربع» where migration applies). Filtered empty = a plain card «لا نتائج
// في هذه الفترة.» WITHOUT the mark.

import type { ReactNode } from 'react';
import { BrandMark } from './BrandMark';

export const FILTERED_EMPTY = 'لا نتائج في هذه الفترة.';

export interface EmptyStateProps {
  /** The one sentence, e.g. «لا مصروفات بعد.» */
  title?: ReactNode;
  /** Optional supporting line (slate). */
  body?: ReactNode;
  /** The decisive action (usually a <PrimaryAction>). */
  action?: ReactNode;
  /** A secondary line button (e.g. «استيراد من المربع»). */
  secondary?: ReactNode;
  /** Filtered/period empty: plain card, no mark. */
  filtered?: boolean;
  'data-testid'?: string;
}

export function EmptyState({ title, body, action, secondary, filtered, 'data-testid': testId }: EmptyStateProps) {
  if (filtered) {
    return (
      <div className="e-empty-filtered" role="status" data-testid={testId}>
        {title ?? FILTERED_EMPTY}
      </div>
    );
  }
  return (
    <section className="e-empty" data-testid={testId}>
      <BrandMark mode="empty" size={96} className="e-empty-mark" />
      {title && <h2 className="e-empty-title">{title}</h2>}
      {body && <p className="e-empty-body">{body}</p>}
      {(action || secondary) && (
        <div className="e-empty-actions">
          {action}
          {secondary}
        </div>
      )}
    </section>
  );
}
